<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="app-container">
    <traveler-data :agency-code="agencyCode" />
  </div>
</template>

<script>
export default {
  name: 'Traveler',
  components: {
    travelerData: () => import('@/views/ita/components/travelerData.vue'),
  },
  data() {
    return {
      agencyCode: null,
    }
  },
  created() {
    this.agencyCode = this.$store.getters.userInfo.agencyCode
  },
}
</script>
